import { useState } from "react"
import { FiInfo } from "react-icons/fi"
import { Box, CloseButton, Dialog, HStack, Portal, Stack } from "@chakra-ui/react"
import { Text } from "@/components"
import { DropZoneContainer } from "@/features/documents/components"

interface UploadModalProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description?: string
  tooltipContent?: React.ReactNode
  uploadDocuments: (files: File[]) => void
  isLoading: boolean
  isSuccess: boolean
}

export const UploadModal = ({ isOpen, onOpenChange, title, description, tooltipContent, uploadDocuments, isLoading, isSuccess }: UploadModalProps) => {
  const [showTooltip, setShowTooltip] = useState(false)

  return (
    <Dialog.Root open={isOpen} onOpenChange={(e) => { onOpenChange(e.open); if (!e.open) setShowTooltip(false) }}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content p={6}>
            <HStack>
              <HStack gap={0}>
                <Dialog.Title>{title}</Dialog.Title>
                {tooltipContent && (
                  <Box
                    as="span"
                    cursor="pointer"
                    display="inline-flex"
                    alignItems="center"
                    ml={1}
                    onClick={() => setShowTooltip(!showTooltip)}
                  >
                    <FiInfo size={14} color={showTooltip ? "#3182CE" : "#718096"} />
                  </Box>
                )}
              </HStack>
              <Dialog.CloseTrigger asChild>
                <CloseButton size="sm" />
              </Dialog.CloseTrigger>
            </HStack>
            <Dialog.Body mt={4}>
              <Stack gap={4}>
                {description && (
                  <Text fontSize="sm" color="gray.500">{description}</Text>
                )}
                {showTooltip && tooltipContent && (
                  <Box px={3} py={2} bg="blue.50" borderRadius="md" borderWidth="1px" borderColor="blue.100">
                    {tooltipContent}
                  </Box>
                )}
                <DropZoneContainer
                  uploadDocuments={uploadDocuments}
                  isLoading={isLoading}
                  isSuccess={isSuccess}
                />
              </Stack>
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
